export const URL_CLUB_BENEFICIARIO = "https://www.arssenasa.gob.do/club/"
export const URL_CLUB_BENEFICIARIO_SUBSIDIADO = "https://www.arssenasa.gob.do/clubrs/"